import axios from 'axios'
import Vuex from 'vuex'
import Vue from 'vue'
import store from '../store'

Vue.use(Vuex, axios)

const getSearchUrl = function() {
  const buildYourJewelMode = store.getters['buildYourJewel/getBuildYourJewelMode']
  return buildYourJewelMode ? `${process.env.VUE_APP_BASE_URL}/build-your-jewel/setting/search` : `${process.env.VUE_APP_BASE_URL}/search`;
}

export default {
  searchJewels(cb, searchJewel) {
    const credential = store.getters['config/getCredential']
    const buildYourJewelModeStones = store.getters['buildYourJewel/getSelectedStones'];
    const buildYourJewelStonesNumber = store.getters['buildYourJewel/getStonesNumber'];
    var userLang = navigator.language || navigator.userLanguage
    var headerObj = {};
    if (credential) {
      if (!credential.locale) {
        credential.locale = userLang.replace('-', '_')
      }
      if (credential && credential.apiEncryptedUser) {
        headerObj = {
          'X-ApiEncryptedUser': credential.apiEncryptedUser
        }
      } else if (credential.apiSecret) {
        headerObj = {
          'X-ApiKey': credential.apiKey,
          'X-ApiSecret': credential.apiSecret,
        }
      } else if (credential && credential.apiKey) {
        headerObj = {
          'X-ApiKey': credential.apiKey,
        }
      }
    }
    const params = new URLSearchParams();
    params.append('locale', credential?.locale);
    params.append('sort', searchJewel?.sorting);

    // Prepara il body della richiesta
    const requestBody = {
      ...searchJewel,
      brand: credential.brand,
      diamondId: buildYourJewelModeStones && buildYourJewelModeStones[0]?.id,
      jewelStonesNumber: buildYourJewelStonesNumber,
      // Assicurati che category, gold e stoneShape siano array
      category: Array.isArray(searchJewel.category) ? searchJewel.category : (searchJewel.category ? [searchJewel.category] : null),
      goldColor: Array.isArray(searchJewel.goldColor) ? searchJewel.goldColor : (searchJewel.goldColor ? [searchJewel.goldColor] : null),
      stoneShape: Array.isArray(searchJewel.stoneShape) ? searchJewel.stoneShape : (searchJewel.stoneShape ? [searchJewel.stoneShape] : null)
    };

    axios
      .post(
        getSearchUrl(),
        requestBody,
        {
          params: params,
          headers: headerObj
        }
      )
      .then(res => {
        cb(res)
      })
      .catch(error => {
        console.log(error);
      })
  },

  getList(cb, listType, params) {
    const credential = store.getters['config/getCredential'] || {}
    var userLang = navigator.language || navigator.userLanguage
    var headerObj = {};
    if (credential) {
      if (!credential.locale) {
        credential.locale = userLang.replace('-', '_')
      }
      if (credential.apiEncryptedUser) {
        headerObj = {
          'X-ApiEncryptedUser': credential.apiEncryptedUser
        }
      } else if (credential.apiSecret) {
        headerObj = {
          'X-ApiKey': credential.apiKey,
          'X-ApiSecret': credential.apiSecret,
        }
      } else {
        headerObj = {
          'X-ApiKey': credential.apiKey,
        }
      }
    }
    axios
      .get(
        `${process.env.VUE_APP_BASE_URL}/image-list/${listType}?locale=${credential.locale}&brand=${credential.brand}`,
        {
          headers: headerObj,
          params: params
        }
      )
      .then(res => {
        cb(res.data)
      })
      .catch(error => {
        console.log(error);
      })
  },

  getAmaStarterKit() {
    const credential = store.getters['config/getCredential'] || {}
    var userLang = navigator.language || navigator.userLanguage
    var headerObj = {};
    if (credential) {
      if (!credential.locale) {
        credential.locale = userLang.replace('-', '_')
      }
      if (credential.apiEncryptedUser) {
        headerObj = {
          'X-ApiEncryptedUser': credential.apiEncryptedUser
        }
      }
    }
    return axios
      .get(
        `${process.env.VUE_APP_BASE_URL}/ama/starter-kit?locale=${credential.locale}&brand=${credential.brand}`,
        {
          headers: headerObj
        }
      )
  },

  getKitItemsForCart(kitName) {
    const credential = store.getters['config/getCredential'] || {}
    var userLang = navigator.language || navigator.userLanguage
    var headerObj = {};
    if (credential) {
      if (!credential.locale) {
        credential.locale = userLang.replace('-', '_')
      }
      if (credential.apiEncryptedUser) {
        headerObj = {
          'X-ApiEncryptedUser': credential.apiEncryptedUser
        }
      }
    }
    return axios
      .get(
        `${process.env.VUE_APP_BASE_URL}/addKitItemsToCart/${kitName}?locale=${credential.locale}&brand=${credential.brand}`,
        {
          headers: headerObj
        }
      )
  }

}
